export default "__VITE_ASSET__CQVp$d1H__"